import { collection, QueryDocumentSnapshot } from "firebase/firestore";
import { db } from "integrations/firebase/firestore";
import { FirestoreProductImport } from "reedy-data/models";

const productsImportConverter = {
  toFirestore: (record: FirestoreProductImport) => record,
  fromFirestore(
    snapshot: QueryDocumentSnapshot<FirestoreProductImport>,
  ): FirestoreProductImport {
    return snapshot.data();
  },
};

export const getProductsImportCollection = () =>
  collection(db, "productsImport").withConverter(productsImportConverter);

export function getProductGroupDescription(product?: FirestoreProductImport) {
  return product?.baseProduct?.description?.productForm || "";
}

export function getProductTitle(product?: FirestoreProductImport) {
  const titles = product?.baseProduct?.titles || [];
  return titles[0]?.titleText || "";
}

export function getProductAuthors(product?: FirestoreProductImport) {
  const contributors = product?.baseProduct?.contributors || [];
  return contributors.map((author) => author.personName || "");
}

export function getProductPublishedAt(product?: FirestoreProductImport) {
  return product?.baseProduct?.publishingDetails?.publicationDate || "";
}
